import React from "react";
import Text from "./Text/Text";
import Globe from "./Globe/Globe";
import CarouselText from "./CarouselText/CarouselText";
import useReveal from "../../hooks/useReveal";
import "./HeroSection.css";

const HeroSection = () => {
  const heroRef = useReveal();
  const carouselRef = useReveal();

  return (
    <>
      <section id="home" className="hero-wrapper reveal" ref={heroRef}>
        <div className="hero-inner">
          <div className="hero-text">
            <Text />
          </div>
          <div className="hero-globe">
            <Globe />
          </div>
        </div>
      </section>

      <section className="hero-carousel-wrapper reveal" ref={carouselRef}>
        <CarouselText />
      </section>
    </>
  );
};

export default HeroSection;
